import React from 'react';

// Choices are maintained on Input; retain an existing retired value when unchanged.
export default function RatingsTextEditor({ value, onValueChange, values = [] }) {
  return (
    <select
      aria-label="Assignment"
      autoFocus
      value={value ?? ''}
      onChange={(event) => onValueChange(event.target.value)}
      style={{ width: '100%', height: '100%' }}
    >
      {values.map((item) => (
        <option key={item} value={item}>
          {item || '(Unassigned)'}
        </option>
      ))}
    </select>
  );
}
